/* Built Diff Timepieces — theme.js  (vanilla, no dependencies) */
(function () {
  'use strict';

  /* ---- Mobile nav toggle ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (!t) return;
    var nav = document.querySelector('[data-nav]');
    if (nav) nav.classList.toggle('is-open');
  });

  /* ---- Reveal on scroll ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- PDP gallery ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) { main.src = btn.dataset.thumb; }
        g.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  });

  /* ---- PDP variant selection ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = document.getElementById(form.dataset.variantsId);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var submit = form.querySelector('[data-add]');

    function currentOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (grp) {
        var sel = grp.querySelector('input:checked, select');
        if (sel) opts[parseInt(grp.dataset.optionIndex, 10)] = sel.value;
      });
      return opts;
    }
    function match(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function fmt(cents) {
      return '$' + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    var scarcityEl = document.querySelector('[data-scarcity]');
    function update() {
      var v = match(currentOptions());
      if (!v) { if (submit){submit.disabled = true; submit.querySelector('span').textContent = 'Unavailable';} return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceEl.innerHTML = '<s>' + fmt(v.compare_at_price) + '</s> <span class="money--sale">' + fmt(v.price) + '</span>';
        } else {
          priceEl.textContent = fmt(v.price);
        }
      }
      if (submit) {
        submit.disabled = !v.available;
        submit.querySelector('span').textContent = v.available ? 'Add to bag' : 'Sold out';
      }
      /* Scarcity update on variant change */
      if (scarcityEl) {
        if (v.available && v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= 10) {
          scarcityEl.innerHTML = '<span class="scarcity__dot"></span> Only ' + v.inventory_quantity + ' remaining';
          scarcityEl.className = 'pdp__scarcity';
          scarcityEl.style.display = '';
        } else if (!v.available) {
          scarcityEl.textContent = 'Sold out';
          scarcityEl.className = 'pdp__scarcity pdp__scarcity--gone';
          scarcityEl.style.display = '';
        } else {
          scarcityEl.style.display = 'none';
        }
      }
    }
    form.addEventListener('change', update);
    update();
  });

  /* ---- Countdown ---- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.dataset.countdown).getTime();
    if (isNaN(target)) return;
    var fields = {
      d: el.querySelector('[data-cd-d]'), h: el.querySelector('[data-cd-h]'),
      m: el.querySelector('[data-cd-m]'), s: el.querySelector('[data-cd-s]')
    };
    function tick() {
      var diff = Math.max(0, target - Date.now());
      var d = Math.floor(diff / 864e5);
      var h = Math.floor(diff % 864e5 / 36e5);
      var m = Math.floor(diff % 36e5 / 6e4);
      var s = Math.floor(diff % 6e4 / 1e3);
      if (fields.d) fields.d.textContent = d;
      if (fields.h) fields.h.textContent = ('0' + h).slice(-2);
      if (fields.m) fields.m.textContent = ('0' + m).slice(-2);
      if (fields.s) fields.s.textContent = ('0' + s).slice(-2);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* Multi-step application engine now lives inline in sections/bespoke-application.liquid
     so it is self-contained and re-inits inside the Shopify theme editor. */
})();
